<template>
  <v-app-bar app color="primary">
    <v-btn v-if="inMain" text :color="color" @click="signOutDialog = true" :icon="xsOnly">
      <v-icon size="22" :color="color">power_settings_new</v-icon>
      <span v-if="smAndUp" class="ml-2">{{ $t("actions.sign_out") }}</span>
    </v-btn>
    <v-btn v-else :color="color" @click="goHome()" icon :class="{ 'ml-0': smAndUp }">
      <v-icon :size="mdAndUp ? 28 : 24" :color="color">mdi-home</v-icon>
    </v-btn>
    <v-spacer />
    <logo theme="light" :height="40" style="height: 40px" />

    <v-dialog v-model="signOutDialog" persistent width="300">
      <v-card>
        <v-card-title>
          {{$t('actions.sign_out')}}
        </v-card-title>
        <v-card-text>
          {{$t('sign_out.warning')}}
          <span v-if="showPasswordWarning">{{$t('sign_out.no_password')}}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="signOutDialog = false">{{ $t('actions.cancel') }}</v-btn>
          <v-btn color="primary darken-1" text  @click="$store.dispatch('auth/signOut')">{{ $t('actions.accept') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import { textColor } from '@/lib/helpers/ColorUtils'
import { mapState } from 'vuex'
import vuetifyMixins from '@/mixins/Vuetify'
import routeNames from '@/router/routes'
import router from '@/router'
export default {
  data () {
    return {
      routeNames,
      signOutDialog: false,
      showPasswordWarning: false,
      color: textColor(this.$vuetify.theme.themes.light.primary.base),
    }
  },
  computed: {
    inMain () {
      return this.$route.name === routeNames.main.name
    },
    configuration () {
      return this.$store.state.service.configuration
    },
    customization () {
      if (this.configuration !== null) {
        return this.configuration.customization
      } else {
        return null
      }
    },
    compact () {
      if (this.customization !== null && this.customization.logo !== null) {
        return this.configuration.customization.logo.compact
      } else {
        return null
      }
    },
    appTitle () {
      if (this.customization !== null && this.customization.appTitle !== null) {
        let languageCode = this.$i18n.locale
        let appTitle = this.configuration.customization.appTitle.filter(
          (name) => name.languageCode === languageCode
        )[0]
        return appTitle.value
      } else {
        return null
      }
    },
    settings () {
      return this.$store.state.me.settings
    },
    ...mapState(['state']),
  },
  methods: {
    goHome () {
      router.push({ name: routeNames.main.name })
    },
    setFavicon (val) {
      var link = document.querySelector('link[rel*=\'icon\']')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = val
      document.getElementsByTagName('head')[0].appendChild(link)
    },
  },
  components: {
    Logo: () => import('@/components/app-components/Logo.vue'),
  },
  watch: {
    compact: function (val) {
      if (val !== null) {
        this.setFavicon(val)
      }
    },
    appTitle: function (val) {
      if (val !== null) {
        document.title = val
      }
    },
    settings: {
      immediate: true,
      handler: function (newValue, oldValue) {
        if (!newValue) {
          return
        }
        if (
          !newValue.hasPassword &&
          (!localStorage.getItem('dismissedForToken') ||
            localStorage.getItem('dismissedForToken') !==
              localStorage.getItem('token'))
        ) {
          this.showPasswordWarning = true
        }
      },
    },
  },
  created () {
    if (this.compact !== null) {
      this.setFavicon(this.compact)
    }
    if (this.appTitle !== null) {
      document.title = this.appTitle
    }
  },
  mixins: [
    vuetifyMixins,
  ],
}
</script>

<style lang="scss">
.v-app-bar {
  .v-btn {
    text-transform: none;
  }
}
</style>
